/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import { isEmpty } from 'serenova-js-utils/strings';
import store from '../../../redux/store';
import {
  selectExistingTypes,
  selectExistingSubtypes,
  formTypeHasSubtypes,
  isCreatingEntity,
} from '../../../redux/modules/entities/alps/selectors';

const getTypeMessage = (type) => {
  const existingTypes = selectExistingTypes(store.getState());
  let typeMessage = null;
  if (isEmpty(type)) {
    typeMessage = 'Please enter a type.';
  } else if (
    isCreatingEntity(store.getState()) &&
    existingTypes.includes(type) &&
    !formTypeHasSubtypes(store.getState())
  ) {
    typeMessage = 'Cannot create a policy with an existing artifact type.';
  }
  return typeMessage;
};

const getSubtypeMessage = (type, subtype) => {
  let subtypeMessage = null;
  if (formTypeHasSubtypes(store.getState())) {
    const existingSubtypes = selectExistingSubtypes(store.getState());
    if (isEmpty(subtype)) {
      subtypeMessage = 'Please enter a subtype.';
    } else if (isCreatingEntity(store.getState()) && existingSubtypes.includes(subtype)) {
      subtypeMessage = 'Cannot create a policy with an existing artifact subtype.';
    }
  }
  return subtypeMessage;
};

const getAfterMessage = (after) => {
  let afterMessage = null;
  if (isEmpty(after)) {
    afterMessage = 'Please enter an expiration time.';
  } else if (after < 0) {
    afterMessage = 'Please enter a positive number.';
  }
  return afterMessage;
};
const getCheck = (artifactTypeId,artifactSubType) => { 
  if(formTypeHasSubtypes(store.getState())){
    return isEmpty(artifactSubType) || artifactSubType == undefined || artifactSubType == '';
  }else {
    return false;
  }
}

export const formValidation = (values) => ({
  name: isEmpty(values.get('name')) && 'Please enter a name.',
  description: isEmpty(values.get('description')) && 'Please enter a Description.',
  artifactTypeId: isEmpty(values.get('artifactTypeId')) && 'Please enter a Artifact Type.',
  // artifactType: getTypeMessage(values.get('artifactType')),
  // artifactSubType:getSubtypeMessage(values.get('artifactTypeId'), values.get('artifactSubType')),
  artifactSubType: getCheck(values.get('artifactTypeId'),values.get('artifactSubType')) && 'Please enter Artifact Subtype.',
  action: isEmpty(values.get('action')) && 'Please enter an action',
  after: getAfterMessage(values.get('after')),
});

export const versionsFormValidation = values => {
  var obj = {
    versionName: isEmpty(values.get('versionName')) && 'Please enter version name',
    activeAction: isEmpty(values.get('activeAction')) && 'Please select Active Action'
  }

  if (values.get('activeAction') == "Delete") {
    obj.activeDuration = (isEmpty(values.get('activeDuration')) && 'Please enter Active Duration ( value of Active Duration should be less than 9999 and greater than 0)')
  }
  return (obj);
};

export const termsFormValidation = (values) => ({
  storageLimitCosts: !values.get('storageLimitCosts') && 'Please select to continue.',
  // billingPerGB: !values.get('billingPerGB') && 'Please select to continue.',
  // retrieveFromStorage: !values.get('retrieveFromStorage') && 'Please select to continue.',
  deletedArtifacts: !values.get('deletedArtifacts') && 'Please select to continue.',
});
